import { BenefitActivityLogItemType } from "../benefits-log/Types";
import { sortLogsLatestFirst } from "../benefits-log/sortLogs";
import {
  BenefitActivityDashboardBenefitApiType,
  BenefitActivityDashboardData,
  BenefitActivityDashboardPartner,
  BenefitActivityDashboardQueryType,
  BenefitActivityDashboardResponseType,
} from "./Types";

const toCount = (value: unknown): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

const isDelivered = (status: string | null | undefined) =>
  (status || "").trim().toLowerCase() === "delivered";

const isNotDeliveredLabel = (label: string) =>
  /not[\s-]*delivered/i.test(label);

const mapBenefitToLogItem = (
  benefit: BenefitActivityDashboardBenefitApiType,
  partnerId: number,
  partnerName: string
): BenefitActivityLogItemType => ({
  ID: benefit.benefit_log_id,
  partner_id: partnerId,
  partner_name: partnerName,
  benefit_id: benefit.benefit_id,
  benefits_name: benefit.benefit_name,
  category_name: benefit.category_name || "",
  planned_date: benefit.planned_date,
  delivered_date: benefit.delivered_date,
  HID_user_id: benefit.HID_user_id || [],
  partner_user_id: benefit.partner_user_id || [],
  status: benefit.status,
  comments: benefit.comments,
  media: [],
  created_by: null,
  created_at: "",
  updated_at: "",
});

export const mapBenefitActivityDashboardResponse = (
  response: BenefitActivityDashboardResponseType | undefined,
  query: BenefitActivityDashboardQueryType
): BenefitActivityDashboardData => {
  const partners: BenefitActivityDashboardPartner[] = (response?.data || []).map(
    (partner) => {
      const partnerId = Number(partner.partner_id);
      const partnerName = partner.partner_name || "-";
      const logs = sortLogsLatestFirst(
        (Array.isArray(partner.benefits) ? partner.benefits : []).map((benefit) =>
          mapBenefitToLogItem(benefit, partnerId, partnerName)
        )
      );
      const apiLabel = (partner.delivery_status || "").trim();
      if (apiLabel) {
        return {
          partnerId,
          partnerName,
          deliveryStatusLabel: apiLabel,
          isDelivered: !isNotDeliveredLabel(apiLabel),
          logs,
        };
      }
      const deliveredCount = logs.filter((log) => isDelivered(log.status)).length;
      return {
        partnerId,
        partnerName,
        deliveryStatusLabel: `${deliveredCount}/${logs.length} ${
          deliveredCount > 0 ? "Delivered" : "Not - Delivered"
        }`,
        isDelivered: deliveredCount > 0,
        logs,
      };
    }
  );

  const summary = response?.summary || {};
  const pagination = response?.pagination || {};

  return {
    summary: {
      total: toCount(summary.totalBenefits),
      delivered: toCount(summary.delivered),
      inProgress: toCount(summary.inProgress),
      overdue: toCount(summary.overdue),
    },
    partners,
    pagination: {
      currentPage: toCount(pagination.current_page) || query.page,
      perPage: toCount(pagination.per_page) || query.limit,
      totalRecords: toCount(pagination.total_records),
    },
  };
};
